module["exports"] = [
  "Avon",
  "Bedfordshire",
  "Berkshire",
  "Borders",
  "Buckinghamshire",
  "Cambridgeshire"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/county.js
// module id = 895
// module chunks = 0